/** The key the signed-in user is persisted under, without its access token. */
export const CURRENT_USER_KEY = 'currentUser';

/** The persisted user, or null when there is none or it cannot be read. Never throws. */
export function readStoredCurrentUser(): any | null {
  try {
    const value = JSON.parse(localStorage.getItem(CURRENT_USER_KEY) || 'null');
    return value && typeof value === 'object' ? value : null;
  } catch (_) {
    return null;
  }
}

/**
 * Whose preferences a session carries: the actor's while impersonating, since an admin keeps
 * their own layout and bookmarks while looking through someone else's account.
 */
export function preferencesOwnerId(user: any): number | null {
  if (user?.impersonation?.active && user.impersonation.actor_id != null) {
    return Number(user.impersonation.actor_id);
  }
  return user?.id != null ? Number(user.id) : null;
}
